"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixTable = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const matrix_view_model_components_1 = require("./matrix-view-model.components");
const partials_1 = require("../../cells/partials");
const constants_1 = require("../../constants");
const attribute_mapping_menu_component_1 = require("../context-menu/attribute-mapping-menu.component");
const matrix_context_menu_1 = require("../context-menu/matrix-context-menu");
const matrix_table_no_data_and_default_state_component_1 = require("./matrix-table-no-data-and-default-state.component");
const strategy_matrix_skeleton_1 = require("../strategy-matrix-skeleton");
const table_styles_1 = require("../table.styles");
const store_1 = require("../../../../store");
const MATRIX_ROW_HEIGHT = 36;
const GRID_SCROLLBAR_SIZE = 14;
const MATRIX_FOOTER_SCROLL_RESERVE = MATRIX_ROW_HEIGHT - GRID_SCROLLBAR_SIZE;
const MatrixTable = (_a) => {
    var { selectedAttributes = [] } = _a, props = __rest(_a, ["selectedAttributes"]);
    const firstAttr = selectedAttributes[0];
    const productTreeRootNodeId = (0, store_1.useProductTreeRootNodeId)();
    const [managedAttributeName, setManagedAttributeName] = (0, react_1.useState)(null);
    const vm = (0, matrix_view_model_components_1.useMatrixViewModel)({
        selectedAttribute: firstAttr,
        selectedStrategyNodeId: props.selectedStrategyNodeId,
        selectedCatalogId: props.selectedCatalogId,
        selectedProductTreeId: props.selectedProductTreeId,
        selectedL1Categories: props.selectedL1Categories,
        selectedDisplayTable: props.selectedDisplayTable,
        onManageAttribute: setManagedAttributeName,
    });
    const { contextMenu, open, close } = (0, matrix_context_menu_1.useMatrixContextMenu)();
    const renderGridContent = () => {
        if (vm.isLoading || props.categoriesIsLoading)
            return react_1.default.createElement(strategy_matrix_skeleton_1.StrategyMatrixGridSkeleton, null);
        if (!firstAttr || vm.error) {
            return react_1.default.createElement(matrix_table_no_data_and_default_state_component_1.NoDataAndDefaultState, { errorMessage: vm.error, selectedAttribute: firstAttr });
        }
        return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        react_1.default.createElement("div", { style: { position: 'relative' }, onContextMenu: (event) => {
                const { target } = event;
                if (!(target instanceof Element))
                    return;
                const cell = target.closest('.MuiDataGrid-cell');
                const rowElement = target.closest('.MuiDataGrid-row');
                const field = cell === null || cell === void 0 ? void 0 : cell.dataset.field;
                const rowId = rowElement === null || rowElement === void 0 ? void 0 : rowElement.dataset.id;
                if (!field || !rowId || field === constants_1.TOTAL_PRODUCT_COUNT_FIELD)
                    return;
                const rowIndex = vm.rowData.findIndex(({ id }) => id === rowId);
                const row = vm.rowData[rowIndex];
                if (!row)
                    return;
                open(event, row, rowIndex, field, vm.flattenedDataMap, vm.displayedProductTitles);
            }, onClick: close }, react_1.default.createElement(table_styles_1.StyledGridContainer, null, react_1.default.createElement(ui_components_1.AdvancedDataGrid, { columns: vm.columnDefs, rows: vm.rowData, pinnedRows: { bottom: vm.pinnedBottomRowData }, slotProps: {
                columnMenu: {
                    slots: {
                        columnMenuSortItem: null,
                        columnMenuFilterItem: null,
                        columnMenuColumnsItem: null,
                    },
                },
            }, initialState: {
                pinnedColumns: {
                    left: ['value', constants_1.TOTAL_PRODUCT_COUNT_FIELD],
                },
            }, rowHeight: MATRIX_ROW_HEIGHT, getRowSpacing: ({ isLastVisible }) => ({
                bottom: isLastVisible ? MATRIX_FOOTER_SCROLL_RESERVE : 0,
            }), columnHeaderHeight: 48, scrollbarSize: GRID_SCROLLBAR_SIZE, pinnedRowsSectionSeparator: "border", hideFooter: true, disableColumnMenu: false, disableColumnReorder: true, disableRowSelectionOnClick: true, enableVirtualization: true })), (contextMenu === null || contextMenu === void 0 ? void 0 : contextMenu.show) && (react_1.default.createElement(attribute_mapping_menu_component_1.AttributeMappingMenu, { x: contextMenu.x, y: contextMenu.y, isMapped: contextMenu.isMapped, title: contextMenu.title, value: contextMenu.value, colId: contextMenu.colId, cellType: contextMenu.cellType, selectedStrategyNodeId: props.selectedStrategyNodeId, selectedAttributeName: selectedAttributes[0], displayedProductTitles: vm.displayedProductTitles, onClose: close, onMappingChange: (key, isMapped) => {
                vm.handleMappingChange(key, isMapped);
            } }))));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, renderGridContent(), managedAttributeName && (react_1.default.createElement(partials_1.EditGuidelineDialog, { selectedAttribute: managedAttributeName, selectedStrategyNodeId: productTreeRootNodeId, onClose: () => setManagedAttributeName(null) }))));
};
exports.MatrixTable = MatrixTable;
exports.default = exports.MatrixTable;
